import { SurveyFormFace } from "helpers/enum";

// Mirrors vendor/roi-tripetto/runner/styles.ts (CRA can't import outside src/); a test keeps them in sync.
const inputs = () => ({
  borderSize: 1,
  roundness: 8,
  errorColor: "red",
  agreeColor: "#ee4578",
  declineColor: "#404042",
  backgroundColor: "#fff",
  selectionColor: "#ee4578",
});

const common = () => ({
  mode: "paginated",
  autoFocus: false,
  showEnumerators: false,
  showPageIndicators: false,
  showProgressbar: false,
  noBranding: true,
  font: { size: 14, family: "Nunito" },
  inputs: inputs(),
});

export const SURVEY_RUNNER_DEFAULTS = {
  [SurveyFormFace.Autoscroll]: { ...common(), buttons: { mode: "fill", roundness: 8, finishColor: "#ee4578", baseColor: "#404042" } },
  [SurveyFormFace.Chat]: { ...common(), buttons: { mode: "fill", roundness: 8, baseColor: "#404042" } },
  [SurveyFormFace.Classic]: { ...common(), buttons: { mode: "fill", roundness: 8, finishColor: "#ee4578", baseColor: "#404042" } },
};
